import { BellMinus, BellPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useFollowActions } from '@/hooks/useFollowActions';

/**
 * Subscribe/unsubscribe button for profile pages (kind 3 follow list).
 * Hidden when logged out or when viewing your own profile.
 */
export function FollowButton({ pubkey }: { pubkey: string }) {
  const { user } = useCurrentUser();
  const { isFollowing, isLoading, follow, unfollow, isPending } = useFollowActions(pubkey);

  if (!user || user.pubkey === pubkey) return null;

  return (
    <Button
      variant={isFollowing ? 'secondary' : 'default'}
      size="sm"
      className="gap-1.5 rounded-full"
      disabled={isLoading || isPending}
      onClick={() => (isFollowing ? unfollow() : follow())}
    >
      {isFollowing ? (
        <>
          <BellMinus className="h-4 w-4" />
          {isPending ? 'Unsubscribing…' : 'Subscribed'}
        </>
      ) : (
        <>
          <BellPlus className="h-4 w-4" />
          {isPending ? 'Subscribing…' : 'Subscribe'}
        </>
      )}
    </Button>
  );
}
